import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import { SharedBreadcrumbs } from '../../components/global/SharedBreadcrumbs/SharedBreadcrumbs';

function BuySharedBreadcrumbsComponent({ buyPage }) {
    return buyPage.breadcrumbs.length ? (
        <SharedBreadcrumbs breadcrumbs={buyPage.breadcrumbs} />
    ) : null;
}

BuySharedBreadcrumbsComponent.propTypes = {
    buyPage: PropTypes.object.isRequired,
};

export const BuySharedBreadcrumbs = createFragmentContainer(BuySharedBreadcrumbsComponent, {
    buyPage: graphql`
        fragment BuySharedBreadcrumbs_buyPage on BuyPageConnection {
            breadcrumbs {
                path
                displayName
            }
        }
    `,
});
